<template>
  <!-- 活动选择下拉框组件，仅需传入value即可 -->
  <a-select :value="value" @change="handleChange" style="width:200px;">
    <a-select-option
      v-for="item in activitiesList"
      :key="item.activityId"
      :value="item.activityId"
    >
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'ActivitySelector',
  computed: {
    activitiesList() {
      return this.$store.state.link.allActivitiesList
    },
  },
  props: {
    value: {
      type: [String, Number],
      default: undefined,
    },
  },
  methods: {
    handleChange(val) {
      this.$emit('update:value', val)
      this.$emit('change', val)
    },
  },
}
</script>

<style></style>
